import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BasePopupActionPayload, BasePopupProps } from 'contexts/PopupContext';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Popup } from 'components/UI/Popup';

import { ReactComponent as BanIcon } from './images/ban.svg';

import css from './userBanPopup.module.sass';

type ActionsPayload = BasePopupActionPayload<'close'>;

type Props = BasePopupProps<null, (action: ActionsPayload) => void>;

export const UserBanPopup: React.FC<Props> = ({ onAction }) => {
  const { t } = useTranslation('app');

  const handleClose = useCallback(() => {
    onAction({ type: 'close' });
  }, [onAction]);

  return (
    <Popup bodyClassName={css.root}>
      <BanIcon />
      <p className={css.title}>{t('userBanned')}</p>
      <BaseButton
        type={ButtonTypes.Accent}
        className={css.btn}
        onClick={handleClose}
      >
        {t('ok')}
      </BaseButton>
    </Popup>
  );
};
